import React from 'react';
export function AlgemeneVoorwaarden() {
  return <div className="container mx-auto px-4 py-12 max-w-4xl" data-id="element-287">
      <h1 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-288">
        Algemene Voorwaarden
      </h1>

      <div className="space-y-8 text-gray-700" data-id="element-289">
        <section data-id="element-290">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-291">1. Algemeen</h2>
          <p className="mb-4" data-id="element-292">
            Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen,
            bestellingen en overeenkomsten van De Maekerij. Door het plaatsen
            van een bestelling of het boeken van een workshop gaat u akkoord met
            deze voorwaarden.
          </p>
          <p data-id="element-293">
            De Maekerij behoudt zich het recht voor deze voorwaarden te allen
            tijde te wijzigen. De gewijzigde voorwaarden zijn van toepassing
            vanaf het moment van publicatie op de website.
          </p>
        </section>

        <section data-id="element-294">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-295">
            2. Verkoopsvoorwaarden
          </h2>
          <p className="mb-4" data-id="element-296">
            Alle prijzen vermeld op de website zijn inclusief BTW, tenzij anders
            vermeld. Betaling dient te geschieden via de aangeboden
            betaalmethoden op het moment van boeking of aankoop.
          </p>
          <p data-id="element-297">
            Na betaling ontvangt u een bevestiging per e-mail. Deze bevestiging
            geldt als bewijs van inschrijving of aankoop. Controleer deze
            bevestiging goed op eventuele fouten.
          </p>
        </section>

        <section data-id="element-298">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-299">
            3. Annuleringsvoorwaarden Workshops
          </h2>
          <p className="mb-4" data-id="element-300">
            Bij annulering tot 14 dagen voor aanvang van de workshop wordt het
            volledige inschrijvingsgeld terugbetaald, verminderd met €5
            administratiekosten.
          </p>
          <p className="mb-4" data-id="element-301">
            Bij annulering tussen 14 en 7 dagen voor aanvang wordt 50% van het
            inschrijvingsgeld terugbetaald.
          </p>
          <p data-id="element-302">
            Bij annulering minder dan 7 dagen voor aanvang is geen terugbetaling
            mogelijk. U mag wel zelf voor een vervanger zorgen. Laat ons in dat
            geval weten wie uw plaats inneemt.
          </p>
        </section>

        <section data-id="element-303">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-304">
            4. Annulering door De Maekerij
          </h2>
          <p data-id="element-305">
            Indien er onvoldoende inschrijvingen zijn voor een workshop, behoudt
            De Maekerij zich het recht voor de workshop te annuleren. In dat
            geval wordt het volledige inschrijvingsgeld terugbetaald of kunt u
            kiezen voor een andere datum/workshop.
          </p>
        </section>

        <section data-id="element-306">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-307">
            5. Aansprakelijkheid
          </h2>
          <p data-id="element-308">
            Deelname aan workshops is op eigen risico. De Maekerij is niet
            aansprakelijk voor persoonlijk letsel of schade aan eigendommen
            tijdens workshops of evenementen, tenzij er sprake is van grove
            nalatigheid.
          </p>
        </section>
      </div>
    </div>;
}